import { Flex } from '@Calix-Commerce/design-system';
import styled from '@emotion/styled';

export const Textarea = styled.textarea`
  margin-bottom: 1rem;
  min-width: 50%;
  min-height: 237px;
`;

export const FormContainer = styled(Flex)`
  text-align: center;
`;

export const Title = styled.h1`
  font-size: 2.25em;
  font-weight: normal;
`;
